import { useEffect } from "react";
import { Mission, Vision, Whoarewe } from "../components/Containers";

export default function About(args) {
  useEffect(() => {
    args.setCurrent("about");
    document.title = "Hakkımızda | Zenofy";
  }, [args]);

  return (
    <div style={{}}>
      <Whoarewe noBg device={args.device}></Whoarewe>
      <Mission noBg device={args.device} />
      <Vision noBg device={args.device} />
    </div>
  );
}
